import styled from "styled-components";

export const Wrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  justify-content: flex-end;
  width: 100%;
`;
